import { render, staticRenderFns } from "./NewPurchaseDocumentPage.vue?vue&type=template&id=3ad3d2a2&scoped=true"
import script from "./NewPurchaseDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewPurchaseDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad3d2a2",
  null
  
)

export default component.exports